const React = require('react');
const isNode = (typeof process !== 'undefined');

class ArticleShow extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { data: { excerpt, body, title } } = this.props;

        return (
        <section className="article">
            <div className="article__container">
                <h1 className="article__title">{title}</h1>
                {excerpt && <div className="article__excerpt" dangerouslySetInnerHTML={{ __html: excerpt }}></div>}
                <div className="article__body" dangerouslySetInnerHTML={{ __html: body }}></div>
            </div>
        </section>
        )
    }
}

module.exports = ArticleShow;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/article-show/Component/index.jsx